/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/toggle-mob-menu.js":
/*!***********************************!*\
  !*** ./src/js/toggle-mob-menu.js ***!
  \***********************************/
/***/ (() => {

eval("function toggleMobMenu() {\n  var body = document.body;\n  var btn = document.querySelector('.header .btn-burger');\n  var nav = document.querySelector('header nav');\n  if (!btn) return;\n  btn.addEventListener('click', function () {\n    body.classList.toggle('mobile-menu--show'); // btn.classList.toggle('active')\n    // nav.classList.toggle('active')\n  });\n}\n\ndocument.addEventListener('DOMContentLoaded', function () {\n  toggleMobMenu();\n});\n\n//# sourceURL=webpack://Mahsa/./src/js/toggle-mob-menu.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./src/js/toggle-mob-menu.js"]();
/******/ 	
/******/ })()
;